module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAACRSURBVEiJ7VJbDoAgDFs8GTdznmx6svqzKRII4/FjQn9ISNd2D6KFBSIiAAGA4IUA4FnisXAKmSUu2kXQfx42iUUcAXgkfbFYuzKw28iTPmPwGHmTVw1KoWxXfSSfSX7xQ0t7Ncqdt44lUx9SjS3hnEbs9LC6o2Rw6SutY1L+7iF+rqgD9WB6Da1GMjDahT/jBvMMlkeKh0TZAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cloud.png
// module id = PX72
// module chunks = 0